import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { getLogoId } from '../../htmlElements/htmlElementsIdGetter';
import { css } from '../../../../common/styles/styles.utils';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { brandingDataSelector } from '../../../../common/store/selectors/brandingData.selector';
import { useStyles } from '../../../../common/hooks/useStyles';
import { getBrandLogoStyleObject } from './brandLogo.style';
import { isEmpty } from '../../../../common/utils/utils';

export const BrandLogo: FunctionComponent = () => {
  const playerSize = useSelector(playerDataSelector.playerSize);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const brandingLogoSrc = useSelector(brandingDataSelector.brandingLogoSrc);
  const brandingLogoUrl = useSelector(brandingDataSelector.brandingLogoUrl);

  const showLogo = brandingLogoSrc !== '';
  const styles = useStyles(getBrandLogoStyleObject, [showLogo, playerSize, brandingLogoUrl]);
  const { logoStyle, logoWrapperStyle } = styles;

  return !isEmpty(brandingLogoUrl) ?
    <a
      href={brandingLogoUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={css(logoWrapperStyle)}
    >
      <img id={getLogoId(playerUniqueId)} src={brandingLogoSrc} alt="branding logo" style={logoStyle} />
    </a> :
    <img id={getLogoId(playerUniqueId)} src={brandingLogoSrc} alt="branding logo" style={css(logoWrapperStyle)} />
};
